import React from "react";
import {Button, Form, Input, message} from "antd";
import {connect} from "react-redux";

import {getDetailsToResetPassword, resetPassword} from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import queryString from 'query-string'

const FormItem = Form.Item;

class ResetPassword extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.password === values.password2) {
          const {token} = queryString.parse(this.props.location.search);
          this.props.resetPassword({token, password: values.password});
        } else {
          message.error('Both passwords need to be same!');
        }
      }
    });
  };

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.props.getDetailsToResetPassword({token: values.token});
  }

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/*<img src="https://via.placeholder.com/272x395" alt='Neature'/>*/}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.resetPassword"/></h1>
                <p><IntlMessages id="app.userAuth.bySigning"/></p>
              </div>
              <div className="gx-app-logo">
                <img alt="example" src={'https://www.janusaviation.com/images/logo.gif'}/>
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                <FormItem label={'Enter New Password'}>
                  {getFieldDecorator('password', {
                    rules: [{
                      required: true, message: 'The input is not valid password!',
                    }, {
                      min: 6, max: 28, message: 'Password must be between 6 and 28 characters',
                    }],
                  })(
                    <Input type={'password'} disabled={!this.props.resetTokenValid}/>
                  )}
                </FormItem>
                <FormItem label={'Re-enter New Password'}>
                  {getFieldDecorator('password2', {
                    rules: [{
                      required: true, message: 'The input is not valid password!',
                    }],
                  })(
                    <Input type={'password'} disabled={!this.props.resetTokenValid}/>
                  )}
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={this.props.loading}
                          disabled={!this.props.resetTokenValid}>
                    <IntlMessages id="app.userAuth.resetPassword"/>
                  </Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(ResetPassword);

const mapStateToProps = ({auth, commonData}) => {
  const {token, resetTokenValid} = auth;
  const {error, loading} = commonData;
  const displayMessage = commonData.message;
  return {token, resetTokenValid, error, loading, displayMessage}
};

function mapDispatchToProps(dispatch) {
  return {
    getDetailsToResetPassword,
    resetPassword
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(WrappedNormalLoginForm);
